"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconLandmarkSydneyOperaHouse1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconLandmarkSydneyOperaHouse1, _Icon);
  function IconLandmarkSydneyOperaHouse1(props) {
    var _this;
    _classCallCheck(this, IconLandmarkSydneyOperaHouse1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconLandmarkSydneyOperaHouse1).call(this, props));
    _this.name = 'IconLandmarkSydneyOperaHouse1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "landmark-sydney-opera-house-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "landmark-sydney-opera-house-1_svg__path0",
      d: "M23.473 23.999a5.677 5.677 0 01-3.806-1.734 5.683 5.683 0 01-3.81 1.734c-1.5-.07-2.852-.683-3.857-1.734A5.683 5.683 0 018.191 24c-1.501-.07-2.853-.684-3.858-1.734A5.687 5.687 0 01.524 24H.523a.504.504 0 01-.522-.476.5.5 0 01.476-.523 4.645 4.645 0 003.461-1.806c.093-.121.237-.189.396-.189s.303.069.396.189a4.65 4.65 0 003.462 1.806 4.617 4.617 0 003.413-1.806c.093-.121.237-.19.396-.19s.303.069.396.19a4.646 4.646 0 003.461 1.806 4.62 4.62 0 003.414-1.806.5.5 0 01.791 0 4.646 4.646 0 003.461 1.806.5.5 0 01-.024.999l-.027-.001z"
    }), _react2.default.createElement("path", {
      className: "landmark-sydney-opera-house-1_svg__path1",
      d: "M17.5 6a1.996 1.996 0 01-2.008-1.924 1.978 1.978 0 01.532-1.435 2.009 2.009 0 012.119-.531A3.002 3.002 0 0123.135.885c.565.568.875 1.323.872 2.124a3.005 3.005 0 01-3 2.99H17.5zm3.516-1c.524 0 1.024-.207 1.402-.581.379-.376.589-.878.59-1.412a1.988 1.988 0 00-.581-1.416A1.987 1.987 0 0021.014 1a1.996 1.996 0 00-2.005 1.92.502.502 0 01-.839.347 1.005 1.005 0 00-1.414.053.993.993 0 00-.266.718.99.99 0 00.32.695c.184.171.429.266.689.267h3.517z"
    }), _react2.default.createElement("path", {
      className: "landmark-sydney-opera-house-1_svg__path2",
      d: "M21.5 20a.266.266 0 01-.039-.003h-7.924a.25.25 0 01-.078 0H7.536a.403.403 0 01-.085 0H3.536a.47.47 0 01-.089 0H.5a.5.5 0 010-1h2.115L.386 15.28c-.137-.229-.177-.498-.112-.757a.994.994 0 01.712-.723 4.353 4.353 0 011.134-.153c.825 0 1.649.254 2.423.742L3.34 11.831a1.001 1.001 0 01.816-1.422 7.826 7.826 0 015.345 1.502l-1.168-2.57a1 1 0 01.851-1.412c.193-.012.387-.018.576-.018 5.379 0 7.402 4.702 8.01 6.661.628-.474 1.715-1.055 3.262-1.055.671 0 1.377.111 2.097.329a.996.996 0 01.638 1.328l-1.529 3.823h1.26a.5.5 0 010 1h-1.962A.238.238 0 0121.5 20zm-1.207-1.003L17.5 16.204l-2.793 2.793h5.586zm-7.571 0l-1.254-2.76-2.758 2.76h4.012zm-6.012 0l-.64-1.362-1.361 1.362H6.71zm-4.594-4.349c-.287 0-.58.04-.871.118l2.354 3.927 1.975-1.977c-.481-.65-1.728-2.068-3.458-2.068zm2.718-3.268c-.197 0-.396.008-.591.025l3.407 7.238 3.375-3.378a6.908 6.908 0 00-6.191-3.885zm8.821 7.254l3.295-3.295c-.139-.556-.548-1.938-1.436-3.268-1.4-2.097-3.332-3.161-5.742-3.161-.173 0-.349.005-.527.016l2.846 6.263 1.564 3.445zm7.663-.026l1.521-3.804a6.229 6.229 0 00-1.801-.285c-1.434 0-2.371.594-2.828.981l3.108 3.108z"
    })));
    return _this;
  }
  return IconLandmarkSydneyOperaHouse1;
}(_Icon3.default);
exports.default = IconLandmarkSydneyOperaHouse1;